import type { LanguagesType } from '@/shared/constants/languages'
import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import { LANGUAGES_DASHBOARD_TYPES } from '@/shared/constants/languages'

interface DashboardDisplayLanguageState {
  activeLanguage: LanguagesType
  setActiveLanguage: (language: LanguagesType) => void
}

const ACTIVE_LANG = 'language-storage'

function normalizeDashboardLanguage(language: unknown): LanguagesType {
  if (language === LANGUAGES_DASHBOARD_TYPES.ENG) {
    return LANGUAGES_DASHBOARD_TYPES.ENG
  }
  return LANGUAGES_DASHBOARD_TYPES.VI
}

export const useDashboardDisplayLanguageStore = create<DashboardDisplayLanguageState>()(
  persist(
    (set) => ({
      activeLanguage: LANGUAGES_DASHBOARD_TYPES.VI,
      setActiveLanguage: (language) => {
        set({ activeLanguage: normalizeDashboardLanguage(language) })
      },
    }),
    {
      name: ACTIVE_LANG,
      storage: createJSONStorage(() => localStorage),
      merge: (persistedState, currentState) => ({
        ...currentState,
        ...(typeof persistedState === 'object' && persistedState !== null ? persistedState : {}),
        activeLanguage: normalizeDashboardLanguage(
          typeof persistedState === 'object' &&
            persistedState !== null &&
            'activeLanguage' in persistedState
            ? persistedState.activeLanguage
            : currentState.activeLanguage,
        ),
      }),
      partialize: (state) => ({ activeLanguage: state.activeLanguage }),
    },
  ),
)
